import React from 'react';
import RequestTenantCard from '../RequestTenantCard/RequestTenantCard';
import { RequestInvoiceBlock, requestInvoiceTypes } from '../InvoiceManager';
import styles from './RequestTenantAndBillCard.module.scss';

const RequestTenantAndBillCard = ({ request, canChange, ...props }) => {
  return (
    <div
      {...props}
      className={styles.root}
    >
      <RequestTenantCard
        request={request}
        className={styles.tenant}
      />
      {request.isChargeable ? (
        <>
          <RequestInvoiceBlock
            canChange={canChange}
            request={request}
            className={styles.invoice}
            type={requestInvoiceTypes.otherPages}
          />
        </>
      ) : null}
    </div>
  );
};

export default RequestTenantAndBillCard;
